(function() {
    'use strict';

    angular.module('news', [
            'ui.router',
            'news.services',
            'news.constants'
        ])
        .config(uiRouting);

    uiRouting.$inject = ['$stateProvider', 'userPermissionsConst', 'newsPermissionsConst'];

    function uiRouting($stateProvider, userPermissionsConst, newsPermissionsConst) {
        $stateProvider
            .state('layout.news', {
                abstract: true,
                url: '/news',
                data: {
                    title: 'Aktualności',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.news.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/news/views/news-list/news-list.html',
                        controller: 'NewsListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: newsPermissionsConst.view
                }
            })
            .state('layout.news.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/news/views/news-create/news-create.html',
                        controller: 'NewsCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: newsPermissionsConst.add
                }
            })
            .state('layout.news.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/news/views/news-update/news-update.html',
                        controller: 'NewsUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: newsPermissionsConst.update
                }
            });
    }
})();
